module.exports = __webpack_public_path__ + "img/19.f7ba7292.jpg";